// extracted by mini-css-extract-plugin
export var label = "_cm-5";
export var slideContainer = "_cm-0";
export var slider = "_cm-1";
export var sliderLg = "_cm-4";
export var sliderMd = "_cm-3";
export var sliderSm = "_cm-2";